/**
 * Bordered, height-capped box listing an item's AI reasoning points.
 *
 * The header stays fixed while the reasoning list scrolls internally. Shared
 * between the standalone criterion view and the incorrect-logic feedback form.
 * @module AiReasoningBox
 */
import React from "react";
import { ReasoningPoint } from "../../../data-model/nccnGuidelines";

/** Props for {@link AiReasoningBox}. */
interface AiReasoningBoxProps {
  points: ReasoningPoint[];
}

/**
 * Renders the "AI Reasoning" box, or null when there are no points.
 *
 * @param props - The reasoning points to display
 * @returns The rendered box, or null when empty
 */
export const AiReasoningBox: React.FC<AiReasoningBoxProps> = ({ points }) => {
  if (!points?.length) return null;
  return (
    <div className="flex max-h-60 flex-col items-start justify-center gap-4 self-stretch rounded-md border border-[#E6E6E6] p-4">
      <span className="text-xs font-bold leading-[18px] text-[#6B6B6B]">
        AI Reasoning
      </span>
      <ul className="flex min-h-0 flex-1 flex-col gap-1 overflow-y-auto">
        {points.map((point, index) => (
          <li
            key={index}
            className="self-stretch text-xs font-normal leading-5 text-[#0F0F0F]"
          >
            {point.text}
          </li>
        ))}
      </ul>
    </div>
  );
};
